import styled from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";

export const SwitchLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.3;
  cursor: pointer;
  user-select: none;
`;

export const SwitchInput = styled.input`
  position: absolute;
  width: ${pxToRem(1)};
  height: ${pxToRem(1)};
  margin: ${pxToRem(-1)};
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  border: 0;
  white-space: nowrap;
`;

export const SwitchTrack = styled.span<{ $checked: boolean; $disabled: boolean }>`
  position: relative;
  width: ${pxToRem(34)};
  height: ${pxToRem(19)};
  flex: 0 0 auto;
  border-radius: ${({ theme }) => pxToRem(theme.radii.pill)};
  background: ${({ $checked, theme }) =>
    $checked ? theme.colors.brand : withAlpha(theme.colors.ink, 0.14)};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  transition: background-color 0.15s ease, opacity 0.15s ease;

  &::after {
    content: "";
    position: absolute;
    top: ${pxToRem(3)};
    left: ${pxToRem(3)};
    width: ${pxToRem(13)};
    height: ${pxToRem(13)};
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.sm};
    transform: translateX(${({ $checked }) => ($checked ? pxToRem(15) : "0")});
    transition: transform 0.15s ease;
  }

  ${SwitchInput}:focus-visible + & {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export const SwitchText = styled.span``;
